import { createAction } from "@reduxjs/toolkit";

export type ForbiddenErrorPayload = { method: string; url: string };
export const forbiddenError = createAction<ForbiddenErrorPayload>(
  "FORBIDDEN_API_ERROR",
);

export const invalidActionError = createAction<any>("INVALID_ACTION_ERROR");
